import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  useGetCycleCountQuery,
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import React from 'react'
import { useHistory, useParams } from 'react-router'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
import { CycleCountDetailContent } from './CycleCountDetailContent'
import { CycleCountDetailItemContent } from './CycleCountDetailItemContent'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'

export const CycleCountView = (props: any) => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let history = useHistory()
  const { CycleCountID, CompanyID, WarehouseID }: any = useParams()

  // QUERY //

  const {
    loading: CycleCountLoading,
    error: CycleCountError,
    data: { getCycleCount } = { getCycleCount: [] },
  } = useGetCycleCountQuery({
    fetchPolicy: 'network-only',
    variables: {
      CycleCountID: CycleCountID,
    },
  })

  const value = props.value

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    error: getUsersByAccountAndSoftwareError,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  return (
    <>
      {CycleCountLoading && <Loading />}
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname: `/inventory-control/${WarehouseID}/cycle-count/`,
          })
        }}
        smTitle="Inventory Control"
        title={user?.warehouseName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Inventory Control' },
          { name: 'Cycle Count Detail', current: true },
        ]}
      />

      {/* <DynamicSubHeader
        title={
          <>
            <span className="xsTitle">
              {getBankAccount[0]?.BankProfile?.Name}
            </span>
          </>
        }
        infoLine={
          <>
            <span className="xxTitle">{'Account No.'}&nbsp;:&nbsp;</span>
            <span className="xxTitle">{getBankAccount[0]?.AccountNo}</span>
          </>
        }
      /> */}

      <ContentWrapper
        //   multiDynamicInfo
        float
        footer
      >
        <CardContents
          section={{
            header: {
              title: 'Cycle Count Details',
              icon: (
                <IconText
                  icon={
                    <img
                      src={AuditLog}
                      style={{
                        width: '17px',
                        marginRight: '5px',
                        marginLeft: '12px',
                      }}
                      onClick={() => {
                        history.push({
                          pathname: `/inventory-control/${WarehouseID}/cycle-count/${CycleCountID}/detail/audit-log`,
                          state: {
                            ID: CycleCountID,
                            tableName: 'IC_CycleCount',
                            primaryKey: 'CycleCount',
                            ...getCycleCount,
                          },
                        })
                      }}
                    />
                  }
                  font="desc"
                ></IconText>
              ),
            },
          }}
        >
          <CycleCountDetailContent
            listEl={getCycleCount[0]}
            userList={getUsersByAccountAndSoftware}
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Cycle Count Item Details',
            },
          }}
        >
          <CycleCountDetailItemContent
            listItem={getCycleCount[0]?.CycleCountItem}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
